/**
 * Enumeradores para el módulo de Notificaciones
 */

export enum NotificationFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export const notificationFrequencyDescriptions: Record<NotificationFrequency, string> = {
  [NotificationFrequency.DAILY]: 'notifications.frequency.DAILY',
  [NotificationFrequency.WEEKLY]: 'notifications.frequency.WEEKLY',
  [NotificationFrequency.MONTHLY]: 'notifications.frequency.MONTHLY',
  [NotificationFrequency.YEARLY]: 'notifications.frequency.YEARLY'
};

export enum NotificationSendTo {
  ALL = 'ALL',
  ALL_CLIENTS = 'ALL_CLIENTS',
  ALL_DRIVERS = 'ALL_DRIVERS',
  SPECIFIC_DRIVERS = 'SPECIFIC_DRIVERS',
  CUSTOM = 'CUSTOM'
}

export const notificationSendToDescriptions: Record<NotificationSendTo, string> = {
  [NotificationSendTo.ALL]: 'notifications.target.all',
  [NotificationSendTo.ALL_CLIENTS]: 'notifications.target.all_clients',
  [NotificationSendTo.ALL_DRIVERS]: 'notifications.target.all_drivers',
  [NotificationSendTo.SPECIFIC_DRIVERS]: 'notifications.target.specific_drivers',
  [NotificationSendTo.CUSTOM]: 'notifications.target.custom'
};

export enum NotificationSendBy {
  PUSH = 'PUSH',
  EMAIL = 'EMAIL',
  BOTH = 'BOTH'
}

export const notificationSendByDescriptions: Record<NotificationSendBy, string> = {
  [NotificationSendBy.PUSH]: 'notifications.send_by.push',
  [NotificationSendBy.EMAIL]: 'notifications.send_by.email',
  [NotificationSendBy.BOTH]: 'notifications.send_by.both'
};

export enum NotificationStatus {
  SENT = 'SENT',
  SCHEDULED = 'SCHEDULED',
  CANCELLED = 'CANCELLED'
}

export const notificationStatusDescriptions: Record<NotificationStatus, string> = {
  [NotificationStatus.SENT]: 'notifications.status.sent',
  [NotificationStatus.SCHEDULED]: 'notifications.status.scheduled',
  [NotificationStatus.CANCELLED]: 'notifications.status.cancelled'
};

export enum NotificationCampaignType {
  CUSTOM = 'CUSTOM',
  CUSTOM_TRANSPORT = 'CUSTOM_TRANSPORT',
  SYSTEM = 'SYSTEM'
}

export const notificationCampaignTypeDescriptions: Record<NotificationCampaignType, string> = {
  [NotificationCampaignType.CUSTOM]: 'notifications.type.custom',
  [NotificationCampaignType.CUSTOM_TRANSPORT]: 'notifications.type.custom_transport',
  [NotificationCampaignType.SYSTEM]: 'notifications.type.system'
};
